import { createSlice } from "@reduxjs/toolkit";

const node = () => ({ loading: false, error: null, data: null });

const initialState = {
  // Containment Areas
  containmentAreaListing: node(),
  containmentAreaDetails: node(),
  createContainmentArea: node(),
  updateContainmentArea: node(),
  deleteContainmentArea: node(),
  containmentCalculation: node(),
  calculationHistory: node(),

  // Applicability
  applicabilitySummary: node(),
  campusApplicability: node(),

  // Integrity Profiles
  integrityProfileListing: node(),
  integrityProfileDetails: node(),
  assignIntegrityProfile: node(),

  // Plans
  planListing: node(),
  planDetails: node(),
  generatePlan: node(),
  lockPlan: node(),
  certifyPlan: node(),

  // State Overlays
  stateOverlayListing: node(),
  stateOverlayDetails: node(),
  createStateOverlay: node(),
  updateStateOverlay: node(),
  deleteStateOverlay: node(),

  // Audit
  auditListing: node(),
  auditDetails: node(),

  // Facility Profile (Tier I Template)
  facilityProfile: node(),
  upsertFacilityProfile: node(),
  certifyFacilityProfile: node(),

  // Plan Reviews
  planReviewListing: node(),
  createPlanReview: node(),

  // Dike Drainage Log
  dikeDrainageListing: node(),
  createDikeDrainageLog: node(),

  // Discharge Notifications
  dischargeNotificationListing: node(),
  createDischargeNotification: node(),

  // Tier I Document
  tierIDocument: node(),
};

const spccSlice = createSlice({
  name: "spcc",
  initialState,
  reducers: {
    // Containment Area Listing
    containmentAreaListingStart: (state) => {
      state.containmentAreaListing.loading = true;
      state.containmentAreaListing.error = null;
    },
    containmentAreaListingSuccess: (state, action) => {
      state.containmentAreaListing.loading = false;
      state.containmentAreaListing.data = action.payload;
      state.containmentAreaListing.error = null;
    },
    containmentAreaListingFailure: (state, action) => {
      state.containmentAreaListing.loading = false;
      state.containmentAreaListing.error = action.payload;
    },
    containmentAreaListingReset: (state) => {
      state.containmentAreaListing = node();
    },

    // Containment Area Details
    containmentAreaDetailsStart: (state) => {
      state.containmentAreaDetails.loading = true;
      state.containmentAreaDetails.error = null;
    },
    containmentAreaDetailsSuccess: (state, action) => {
      state.containmentAreaDetails.loading = false;
      state.containmentAreaDetails.data = action.payload;
      state.containmentAreaDetails.error = null;
    },
    containmentAreaDetailsFailure: (state, action) => {
      state.containmentAreaDetails.loading = false;
      state.containmentAreaDetails.error = action.payload;
    },
    containmentAreaDetailsReset: (state) => {
      state.containmentAreaDetails = node();
    },

    // Create Containment Area
    createContainmentAreaStart: (state) => {
      state.createContainmentArea.loading = true;
      state.createContainmentArea.error = null;
      state.createContainmentArea.data = null;
    },
    createContainmentAreaSuccess: (state, action) => {
      state.createContainmentArea.loading = false;
      state.createContainmentArea.data = action.payload;
      state.createContainmentArea.error = null;
    },
    createContainmentAreaFailure: (state, action) => {
      state.createContainmentArea.loading = false;
      state.createContainmentArea.error = action.payload;
    },
    createContainmentAreaReset: (state) => {
      state.createContainmentArea = node();
    },

    // Update Containment Area
    updateContainmentAreaStart: (state) => {
      state.updateContainmentArea.loading = true;
      state.updateContainmentArea.error = null;
      state.updateContainmentArea.data = null;
    },
    updateContainmentAreaSuccess: (state, action) => {
      state.updateContainmentArea.loading = false;
      state.updateContainmentArea.data = action.payload;
      state.updateContainmentArea.error = null;
    },
    updateContainmentAreaFailure: (state, action) => {
      state.updateContainmentArea.loading = false;
      state.updateContainmentArea.error = action.payload;
    },
    updateContainmentAreaReset: (state) => {
      state.updateContainmentArea = node();
    },

    // Delete Containment Area
    deleteContainmentAreaStart: (state) => {
      state.deleteContainmentArea.loading = true;
      state.deleteContainmentArea.error = null;
      state.deleteContainmentArea.data = null;
    },
    deleteContainmentAreaSuccess: (state, action) => {
      state.deleteContainmentArea.loading = false;
      state.deleteContainmentArea.data = action.payload;
      state.deleteContainmentArea.error = null;
    },
    deleteContainmentAreaFailure: (state, action) => {
      state.deleteContainmentArea.loading = false;
      state.deleteContainmentArea.error = action.payload;
    },
    deleteContainmentAreaReset: (state) => {
      state.deleteContainmentArea = node();
    },

    // Containment Calculation
    containmentCalculationStart: (state) => {
      state.containmentCalculation.loading = true;
      state.containmentCalculation.error = null;
      state.containmentCalculation.data = null;
    },
    containmentCalculationSuccess: (state, action) => {
      state.containmentCalculation.loading = false;
      state.containmentCalculation.data = action.payload;
      state.containmentCalculation.error = null;
    },
    containmentCalculationFailure: (state, action) => {
      state.containmentCalculation.loading = false;
      state.containmentCalculation.error = action.payload;
    },
    containmentCalculationReset: (state) => {
      state.containmentCalculation = node();
    },

    // Calculation History
    calculationHistoryStart: (state) => {
      state.calculationHistory.loading = true;
      state.calculationHistory.error = null;
    },
    calculationHistorySuccess: (state, action) => {
      state.calculationHistory.loading = false;
      state.calculationHistory.data = action.payload;
      state.calculationHistory.error = null;
    },
    calculationHistoryFailure: (state, action) => {
      state.calculationHistory.loading = false;
      state.calculationHistory.error = action.payload;
    },
    calculationHistoryReset: (state) => {
      state.calculationHistory = node();
    },

    // Applicability Summary
    applicabilitySummaryStart: (state) => {
      state.applicabilitySummary.loading = true;
      state.applicabilitySummary.error = null;
    },
    applicabilitySummarySuccess: (state, action) => {
      state.applicabilitySummary.loading = false;
      state.applicabilitySummary.data = action.payload;
      state.applicabilitySummary.error = null;
    },
    applicabilitySummaryFailure: (state, action) => {
      state.applicabilitySummary.loading = false;
      state.applicabilitySummary.error = action.payload;
    },
    applicabilitySummaryReset: (state) => {
      state.applicabilitySummary = node();
    },

    // Campus Applicability
    campusApplicabilityStart: (state) => {
      state.campusApplicability.loading = true;
      state.campusApplicability.error = null;
    },
    campusApplicabilitySuccess: (state, action) => {
      state.campusApplicability.loading = false;
      state.campusApplicability.data = action.payload;
      state.campusApplicability.error = null;
    },
    campusApplicabilityFailure: (state, action) => {
      state.campusApplicability.loading = false;
      state.campusApplicability.error = action.payload;
    },
    campusApplicabilityReset: (state) => {
      state.campusApplicability = node();
    },

    // Integrity Profile Listing
    integrityProfileListingStart: (state) => {
      state.integrityProfileListing.loading = true;
      state.integrityProfileListing.error = null;
    },
    integrityProfileListingSuccess: (state, action) => {
      state.integrityProfileListing.loading = false;
      state.integrityProfileListing.data = action.payload;
      state.integrityProfileListing.error = null;
    },
    integrityProfileListingFailure: (state, action) => {
      state.integrityProfileListing.loading = false;
      state.integrityProfileListing.error = action.payload;
    },
    integrityProfileListingReset: (state) => {
      state.integrityProfileListing = node();
    },

    // Integrity Profile Details
    integrityProfileDetailsStart: (state) => {
      state.integrityProfileDetails.loading = true;
      state.integrityProfileDetails.error = null;
    },
    integrityProfileDetailsSuccess: (state, action) => {
      state.integrityProfileDetails.loading = false;
      state.integrityProfileDetails.data = action.payload;
      state.integrityProfileDetails.error = null;
    },
    integrityProfileDetailsFailure: (state, action) => {
      state.integrityProfileDetails.loading = false;
      state.integrityProfileDetails.error = action.payload;
    },
    integrityProfileDetailsReset: (state) => {
      state.integrityProfileDetails = node();
    },

    // Assign Integrity Profile
    assignIntegrityProfileStart: (state) => {
      state.assignIntegrityProfile.loading = true;
      state.assignIntegrityProfile.error = null;
      state.assignIntegrityProfile.data = null;
    },
    assignIntegrityProfileSuccess: (state, action) => {
      state.assignIntegrityProfile.loading = false;
      state.assignIntegrityProfile.data = action.payload;
      state.assignIntegrityProfile.error = null;
    },
    assignIntegrityProfileFailure: (state, action) => {
      state.assignIntegrityProfile.loading = false;
      state.assignIntegrityProfile.error = action.payload;
    },
    assignIntegrityProfileReset: (state) => {
      state.assignIntegrityProfile = node();
    },

    // Plan Listing
    planListingStart: (state) => {
      state.planListing.loading = true;
      state.planListing.error = null;
    },
    planListingSuccess: (state, action) => {
      state.planListing.loading = false;
      state.planListing.data = action.payload;
      state.planListing.error = null;
    },
    planListingFailure: (state, action) => {
      state.planListing.loading = false;
      state.planListing.error = action.payload;
    },
    planListingReset: (state) => {
      state.planListing = node();
    },

    // Plan Details
    planDetailsStart: (state) => {
      state.planDetails.loading = true;
      state.planDetails.error = null;
    },
    planDetailsSuccess: (state, action) => {
      state.planDetails.loading = false;
      state.planDetails.data = action.payload;
      state.planDetails.error = null;
    },
    planDetailsFailure: (state, action) => {
      state.planDetails.loading = false;
      state.planDetails.error = action.payload;
    },
    planDetailsReset: (state) => {
      state.planDetails = node();
    },

    // Generate Plan
    generatePlanStart: (state) => {
      state.generatePlan.loading = true;
      state.generatePlan.error = null;
      state.generatePlan.data = null;
    },
    generatePlanSuccess: (state, action) => {
      state.generatePlan.loading = false;
      state.generatePlan.data = action.payload;
      state.generatePlan.error = null;
    },
    generatePlanFailure: (state, action) => {
      state.generatePlan.loading = false;
      state.generatePlan.error = action.payload;
    },
    generatePlanReset: (state) => {
      state.generatePlan = node();
    },

    // Lock Plan
    lockPlanStart: (state) => {
      state.lockPlan.loading = true;
      state.lockPlan.error = null;
      state.lockPlan.data = null;
    },
    lockPlanSuccess: (state, action) => {
      state.lockPlan.loading = false;
      state.lockPlan.data = action.payload;
      state.lockPlan.error = null;
    },
    lockPlanFailure: (state, action) => {
      state.lockPlan.loading = false;
      state.lockPlan.error = action.payload;
    },
    lockPlanReset: (state) => {
      state.lockPlan = node();
    },

    // Certify Plan
    certifyPlanStart: (state) => {
      state.certifyPlan.loading = true;
      state.certifyPlan.error = null;
      state.certifyPlan.data = null;
    },
    certifyPlanSuccess: (state, action) => {
      state.certifyPlan.loading = false;
      state.certifyPlan.data = action.payload;
      state.certifyPlan.error = null;
    },
    certifyPlanFailure: (state, action) => {
      state.certifyPlan.loading = false;
      state.certifyPlan.error = action.payload;
    },
    certifyPlanReset: (state) => {
      state.certifyPlan = node();
    },

    // State Overlay Listing
    stateOverlayListingStart: (state) => {
      state.stateOverlayListing.loading = true;
      state.stateOverlayListing.error = null;
    },
    stateOverlayListingSuccess: (state, action) => {
      state.stateOverlayListing.loading = false;
      state.stateOverlayListing.data = action.payload;
      state.stateOverlayListing.error = null;
    },
    stateOverlayListingFailure: (state, action) => {
      state.stateOverlayListing.loading = false;
      state.stateOverlayListing.error = action.payload;
    },
    stateOverlayListingReset: (state) => {
      state.stateOverlayListing = node();
    },

    // State Overlay Details
    stateOverlayDetailsStart: (state) => {
      state.stateOverlayDetails.loading = true;
      state.stateOverlayDetails.error = null;
    },
    stateOverlayDetailsSuccess: (state, action) => {
      state.stateOverlayDetails.loading = false;
      state.stateOverlayDetails.data = action.payload;
      state.stateOverlayDetails.error = null;
    },
    stateOverlayDetailsFailure: (state, action) => {
      state.stateOverlayDetails.loading = false;
      state.stateOverlayDetails.error = action.payload;
    },
    stateOverlayDetailsReset: (state) => {
      state.stateOverlayDetails = node();
    },

    // Create State Overlay
    createStateOverlayStart: (state) => {
      state.createStateOverlay.loading = true;
      state.createStateOverlay.error = null;
      state.createStateOverlay.data = null;
    },
    createStateOverlaySuccess: (state, action) => {
      state.createStateOverlay.loading = false;
      state.createStateOverlay.data = action.payload;
      state.createStateOverlay.error = null;
    },
    createStateOverlayFailure: (state, action) => {
      state.createStateOverlay.loading = false;
      state.createStateOverlay.error = action.payload;
    },
    createStateOverlayReset: (state) => {
      state.createStateOverlay = node();
    },

    // Update State Overlay
    updateStateOverlayStart: (state) => {
      state.updateStateOverlay.loading = true;
      state.updateStateOverlay.error = null;
      state.updateStateOverlay.data = null;
    },
    updateStateOverlaySuccess: (state, action) => {
      state.updateStateOverlay.loading = false;
      state.updateStateOverlay.data = action.payload;
      state.updateStateOverlay.error = null;
    },
    updateStateOverlayFailure: (state, action) => {
      state.updateStateOverlay.loading = false;
      state.updateStateOverlay.error = action.payload;
    },
    updateStateOverlayReset: (state) => {
      state.updateStateOverlay = node();
    },

    // Delete State Overlay
    deleteStateOverlayStart: (state) => {
      state.deleteStateOverlay.loading = true;
      state.deleteStateOverlay.error = null;
      state.deleteStateOverlay.data = null;
    },
    deleteStateOverlaySuccess: (state, action) => {
      state.deleteStateOverlay.loading = false;
      state.deleteStateOverlay.data = action.payload;
      state.deleteStateOverlay.error = null;
    },
    deleteStateOverlayFailure: (state, action) => {
      state.deleteStateOverlay.loading = false;
      state.deleteStateOverlay.error = action.payload;
    },
    deleteStateOverlayReset: (state) => {
      state.deleteStateOverlay = node();
    },

    // Audit Listing
    auditListingStart: (state) => {
      state.auditListing.loading = true;
      state.auditListing.error = null;
    },
    auditListingSuccess: (state, action) => {
      state.auditListing.loading = false;
      state.auditListing.data = action.payload;
      state.auditListing.error = null;
    },
    auditListingFailure: (state, action) => {
      state.auditListing.loading = false;
      state.auditListing.error = action.payload;
    },
    auditListingReset: (state) => {
      state.auditListing = node();
    },

    // Audit Details
    auditDetailsStart: (state) => {
      state.auditDetails.loading = true;
      state.auditDetails.error = null;
    },
    auditDetailsSuccess: (state, action) => {
      state.auditDetails.loading = false;
      state.auditDetails.data = action.payload;
      state.auditDetails.error = null;
    },
    auditDetailsFailure: (state, action) => {
      state.auditDetails.loading = false;
      state.auditDetails.error = action.payload;
    },
    auditDetailsReset: (state) => {
      state.auditDetails = node();
    },

    // Facility Profile
    facilityProfileStart: (state) => {
      state.facilityProfile.loading = true;
      state.facilityProfile.error = null;
    },
    facilityProfileSuccess: (state, action) => {
      state.facilityProfile.loading = false;
      state.facilityProfile.data = action.payload;
      state.facilityProfile.error = null;
    },
    facilityProfileFailure: (state, action) => {
      state.facilityProfile.loading = false;
      state.facilityProfile.error = action.payload;
    },
    facilityProfileReset: (state) => {
      state.facilityProfile = node();
    },
    upsertFacilityProfileStart: (state) => {
      state.upsertFacilityProfile.loading = true;
      state.upsertFacilityProfile.error = null;
    },
    upsertFacilityProfileSuccess: (state, action) => {
      state.upsertFacilityProfile.loading = false;
      state.upsertFacilityProfile.data = action.payload;
      state.upsertFacilityProfile.error = null;
    },
    upsertFacilityProfileFailure: (state, action) => {
      state.upsertFacilityProfile.loading = false;
      state.upsertFacilityProfile.error = action.payload;
    },
    upsertFacilityProfileReset: (state) => {
      state.upsertFacilityProfile = node();
    },
    certifyFacilityProfileStart: (state) => {
      state.certifyFacilityProfile.loading = true;
      state.certifyFacilityProfile.error = null;
    },
    certifyFacilityProfileSuccess: (state, action) => {
      state.certifyFacilityProfile.loading = false;
      state.certifyFacilityProfile.data = action.payload;
      state.certifyFacilityProfile.error = null;
    },
    certifyFacilityProfileFailure: (state, action) => {
      state.certifyFacilityProfile.loading = false;
      state.certifyFacilityProfile.error = action.payload;
    },
    certifyFacilityProfileReset: (state) => {
      state.certifyFacilityProfile = node();
    },

    // Plan Reviews
    planReviewListingStart: (state) => {
      state.planReviewListing.loading = true;
      state.planReviewListing.error = null;
    },
    planReviewListingSuccess: (state, action) => {
      state.planReviewListing.loading = false;
      state.planReviewListing.data = action.payload;
      state.planReviewListing.error = null;
    },
    planReviewListingFailure: (state, action) => {
      state.planReviewListing.loading = false;
      state.planReviewListing.error = action.payload;
    },
    planReviewListingReset: (state) => {
      state.planReviewListing = node();
    },
    createPlanReviewStart: (state) => {
      state.createPlanReview.loading = true;
      state.createPlanReview.error = null;
    },
    createPlanReviewSuccess: (state, action) => {
      state.createPlanReview.loading = false;
      state.createPlanReview.data = action.payload;
      state.createPlanReview.error = null;
    },
    createPlanReviewFailure: (state, action) => {
      state.createPlanReview.loading = false;
      state.createPlanReview.error = action.payload;
    },
    createPlanReviewReset: (state) => {
      state.createPlanReview = node();
    },

    // Dike Drainage Log
    dikeDrainageListingStart: (state) => {
      state.dikeDrainageListing.loading = true;
      state.dikeDrainageListing.error = null;
    },
    dikeDrainageListingSuccess: (state, action) => {
      state.dikeDrainageListing.loading = false;
      state.dikeDrainageListing.data = action.payload;
      state.dikeDrainageListing.error = null;
    },
    dikeDrainageListingFailure: (state, action) => {
      state.dikeDrainageListing.loading = false;
      state.dikeDrainageListing.error = action.payload;
    },
    dikeDrainageListingReset: (state) => {
      state.dikeDrainageListing = node();
    },
    createDikeDrainageLogStart: (state) => {
      state.createDikeDrainageLog.loading = true;
      state.createDikeDrainageLog.error = null;
    },
    createDikeDrainageLogSuccess: (state, action) => {
      state.createDikeDrainageLog.loading = false;
      state.createDikeDrainageLog.data = action.payload;
      state.createDikeDrainageLog.error = null;
    },
    createDikeDrainageLogFailure: (state, action) => {
      state.createDikeDrainageLog.loading = false;
      state.createDikeDrainageLog.error = action.payload;
    },
    createDikeDrainageLogReset: (state) => {
      state.createDikeDrainageLog = node();
    },

    // Discharge Notifications
    dischargeNotificationListingStart: (state) => {
      state.dischargeNotificationListing.loading = true;
      state.dischargeNotificationListing.error = null;
    },
    dischargeNotificationListingSuccess: (state, action) => {
      state.dischargeNotificationListing.loading = false;
      state.dischargeNotificationListing.data = action.payload;
      state.dischargeNotificationListing.error = null;
    },
    dischargeNotificationListingFailure: (state, action) => {
      state.dischargeNotificationListing.loading = false;
      state.dischargeNotificationListing.error = action.payload;
    },
    dischargeNotificationListingReset: (state) => {
      state.dischargeNotificationListing = node();
    },
    createDischargeNotificationStart: (state) => {
      state.createDischargeNotification.loading = true;
      state.createDischargeNotification.error = null;
    },
    createDischargeNotificationSuccess: (state, action) => {
      state.createDischargeNotification.loading = false;
      state.createDischargeNotification.data = action.payload;
      state.createDischargeNotification.error = null;
    },
    createDischargeNotificationFailure: (state, action) => {
      state.createDischargeNotification.loading = false;
      state.createDischargeNotification.error = action.payload;
    },
    createDischargeNotificationReset: (state) => {
      state.createDischargeNotification = node();
    },

    // Tier I Document
    tierIDocumentStart: (state) => {
      state.tierIDocument.loading = true;
      state.tierIDocument.error = null;
    },
    tierIDocumentSuccess: (state, action) => {
      state.tierIDocument.loading = false;
      state.tierIDocument.data = action.payload;
      state.tierIDocument.error = null;
    },
    tierIDocumentFailure: (state, action) => {
      state.tierIDocument.loading = false;
      state.tierIDocument.error = action.payload;
    },
    tierIDocumentReset: (state) => {
      state.tierIDocument = node();
    },
  },
});

export const {
  containmentAreaListingStart,
  containmentAreaListingSuccess,
  containmentAreaListingFailure,
  containmentAreaListingReset,
  containmentAreaDetailsStart,
  containmentAreaDetailsSuccess,
  containmentAreaDetailsFailure,
  containmentAreaDetailsReset,
  createContainmentAreaStart,
  createContainmentAreaSuccess,
  createContainmentAreaFailure,
  createContainmentAreaReset,
  updateContainmentAreaStart,
  updateContainmentAreaSuccess,
  updateContainmentAreaFailure,
  updateContainmentAreaReset,
  deleteContainmentAreaStart,
  deleteContainmentAreaSuccess,
  deleteContainmentAreaFailure,
  deleteContainmentAreaReset,
  containmentCalculationStart,
  containmentCalculationSuccess,
  containmentCalculationFailure,
  containmentCalculationReset,
  calculationHistoryStart,
  calculationHistorySuccess,
  calculationHistoryFailure,
  calculationHistoryReset,
  applicabilitySummaryStart,
  applicabilitySummarySuccess,
  applicabilitySummaryFailure,
  applicabilitySummaryReset,
  campusApplicabilityStart,
  campusApplicabilitySuccess,
  campusApplicabilityFailure,
  campusApplicabilityReset,
  integrityProfileListingStart,
  integrityProfileListingSuccess,
  integrityProfileListingFailure,
  integrityProfileListingReset,
  integrityProfileDetailsStart,
  integrityProfileDetailsSuccess,
  integrityProfileDetailsFailure,
  integrityProfileDetailsReset,
  assignIntegrityProfileStart,
  assignIntegrityProfileSuccess,
  assignIntegrityProfileFailure,
  assignIntegrityProfileReset,
  planListingStart,
  planListingSuccess,
  planListingFailure,
  planListingReset,
  planDetailsStart,
  planDetailsSuccess,
  planDetailsFailure,
  planDetailsReset,
  generatePlanStart,
  generatePlanSuccess,
  generatePlanFailure,
  generatePlanReset,
  lockPlanStart,
  lockPlanSuccess,
  lockPlanFailure,
  lockPlanReset,
  certifyPlanStart,
  certifyPlanSuccess,
  certifyPlanFailure,
  certifyPlanReset,
  stateOverlayListingStart,
  stateOverlayListingSuccess,
  stateOverlayListingFailure,
  stateOverlayListingReset,
  stateOverlayDetailsStart,
  stateOverlayDetailsSuccess,
  stateOverlayDetailsFailure,
  stateOverlayDetailsReset,
  createStateOverlayStart,
  createStateOverlaySuccess,
  createStateOverlayFailure,
  createStateOverlayReset,
  updateStateOverlayStart,
  updateStateOverlaySuccess,
  updateStateOverlayFailure,
  updateStateOverlayReset,
  deleteStateOverlayStart,
  deleteStateOverlaySuccess,
  deleteStateOverlayFailure,
  deleteStateOverlayReset,
  auditListingStart,
  auditListingSuccess,
  auditListingFailure,
  auditListingReset,
  auditDetailsStart,
  auditDetailsSuccess,
  auditDetailsFailure,
  auditDetailsReset,
  facilityProfileStart,
  facilityProfileSuccess,
  facilityProfileFailure,
  facilityProfileReset,
  upsertFacilityProfileStart,
  upsertFacilityProfileSuccess,
  upsertFacilityProfileFailure,
  upsertFacilityProfileReset,
  certifyFacilityProfileStart,
  certifyFacilityProfileSuccess,
  certifyFacilityProfileFailure,
  certifyFacilityProfileReset,
  planReviewListingStart,
  planReviewListingSuccess,
  planReviewListingFailure,
  planReviewListingReset,
  createPlanReviewStart,
  createPlanReviewSuccess,
  createPlanReviewFailure,
  createPlanReviewReset,
  dikeDrainageListingStart,
  dikeDrainageListingSuccess,
  dikeDrainageListingFailure,
  dikeDrainageListingReset,
  createDikeDrainageLogStart,
  createDikeDrainageLogSuccess,
  createDikeDrainageLogFailure,
  createDikeDrainageLogReset,
  dischargeNotificationListingStart,
  dischargeNotificationListingSuccess,
  dischargeNotificationListingFailure,
  dischargeNotificationListingReset,
  createDischargeNotificationStart,
  createDischargeNotificationSuccess,
  createDischargeNotificationFailure,
  createDischargeNotificationReset,
  tierIDocumentStart,
  tierIDocumentSuccess,
  tierIDocumentFailure,
  tierIDocumentReset,
} = spccSlice.actions;

export default spccSlice.reducer;
